import React from 'react'

import { PendingReviewBanner } from './PendingReviewBanner'

export const PendingPublicCard: React.FC = () => {
  return (
    <PendingReviewBanner>
      <p className="text-xs leading-relaxed text-gray-600">
        <span className="font-semibold text-graphite-grey">This page has a claim under review.</span>
      </p>
    </PendingReviewBanner>
  )
}
